'use client'

import { useState } from 'react'
import { Button, Icon, Spacer, Text } from '@vinted/web-ui'
import { QuestionCircle24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useCatalogContext, clickEvent } from '@marketplace-web/catalog/catalog-page-data'

import SearchResultsRankingModal from '../common/SearchResultsRankingModal'

import ItemCount from '../ItemCount'

type Props = {
  learnMoreUrl: string | null
}

const ResultRanking = ({ learnMoreUrl }: Props) => {
  const { track } = useTracking()
  const translate = useTranslate('catalog.search_results')
  const [showModal, setShowModal] = useState(false)
  const {
    state: {
      items: { pagination },
    },
  } = useCatalogContext()

  const totalEntries = pagination?.total_entries

  const handleResultRankingClick = () => {
    track(clickEvent({ target: 'catalog_search_results_ranking' }))
    setShowModal(true)
  }

  const handleModalClose = () => {
    setShowModal(false)
  }

  if (!totalEntries) return null

  return (
    <div className="u-ui-padding-vertical-medium u-flexbox u-justify-content-between u-align-items-center">
      <ItemCount />
      {learnMoreUrl && (
        <>
          <Spacer orientation={Spacer.Orientation.Vertical} />
          <Button
            inline
            icon={<Icon name={QuestionCircle24} />}
            iconColor={Icon.Color.GreyscaleLevel3}
            iconPosition={Button.IconPosition.Right}
            onClick={handleResultRankingClick}
            styling={Button.Styling.Flat}
            testId="search_results_ranking_link"
            theme="muted"
          >
            <Text type={Text.Type.Subtitle} text={translate('learn_more_link')} as="span" />
          </Button>
          <SearchResultsRankingModal show={showModal} onConfirmOrClose={handleModalClose} />
        </>
      )}
    </div>
  )
}

export default ResultRanking
